export default __webpack_public_path__ + "static/media/ap-styleguide.8b06cd80.jpg";